
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/mining/lp",
      function () {
        return require("private-next-pages/lon/mining/lp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/mining/lp"])
      });
    }
  